<template>
  <div class="section-full-width">
    <div class="section-boxed">
      <div class="portfolio-carousel">
        <div class="pc-header">
          <div class="carousel-title">
            <h4 class="small-title">Danh sách sản phẩm</h4>
            <a class="link-title" href="/products">
              <span class="more-arrow">&rsaquo;</span>
            </a>
          </div>
        </div>
        <FilterProduct @selectShape="selectShape" @selectDimension="selectDimension"/>
        <!-- <recommend-products :items="products"/> -->
         <new-products :items="products" :maxHeight="200"/>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>
<script>
/* globals Store */
import { mapState } from "vuex";
import { debounce } from "lodash";
import { FilterProduct, NewProducts } from "@/components";
export default {
  components: {
    FilterProduct,
    NewProducts
  },
  computed: {
    ...mapState("products", {
      products: "items",
      pagination: "pagination"
    }),
    quickSearch: {
      get: function() {
        return this.quickSearchFilter;
      },
      set: function(val) {
        this.quickSearchFilter = val;
        // this.quickSearchFilter && this.quickSearchProducts();
      }
    }
  },
  data() {
    return {
      search: "",
      searchVm: {
        contains: {
          name: "",
          shapeId: "",
          dimensionId: ''
        },
        between: {
          unitPrice: {
            former: 0,
            latter: 0
          }
        }
      },
      query: "",
      quickSearchFilter: "",
      shapeId: '',
      dimensionId: ''
    };
  },
  metaInfo() {
    return {
      title: "Sản phẩm"
    };
  },
  mounted() {
    this.getItems();
    this.$store.dispatch("appinfo/setTitle", 'Sản phẩm');
  },
  methods: {
    print() {
      window.print();
    },
    edit(item) {
      this.$router.push({
        name: "Product",
        params: { id: item.Id }
      });
    },
    searchProducts() {
      // this.rightDrawer = !this.rightDrawer;
      // this.appUtil.buildSearchFilters(this.searchVm);
      // this.query = this.appUtil.buildJsonServerQuery(this.searchVm);
      this.query = `shapeId=${this.searchVm.contains.shapeId}&dimensionId=${this.searchVm.contains.dimensionId}`;
      Store.dispatch("products/searchProducts", this.query, this.pagination);
    },
    getItems() {
      this.query = "";
      this.quickSearch = "";
      Store.dispatch("products/getItems", {
        query: this.quickSearchFilter.toLowerCase(),
        pagination: this.pagination
      });
    },
    selectAttribute(shapeId, dimensionId) {
       // this.query = `attributeValueName=${attrValueName}`
       this.searchVm.contains.shapeId = shapeId;
       this.searchVm.contains.dimensionId = dimensionId;
       this.searchProducts()
    },
    selectShape(id) {
       this.searchVm.contains.shapeId = id;
       this.searchProducts()
    },
    selectDimension(id) {
       this.searchVm.contains.dimensionId = id;
       this.searchProducts()
    },
    cancelSearch() {
      this.rightDrawer = false;
    },
    quickSearchProducts: debounce(function() {
      console.log(this.quickSearchFilter);
      this.quickSearchFilter &&
        Store.dispatch("products/quickSearch", {
          headers: this.headers,
          qsFilter: this.quickSearchFilter.toLowerCase(),
          pagination: this.pagination
        });
    }, 300)
  }
};
</script>



// WEBPACK FOOTER //
// index.vue?1cd7d1fa